module.exports = __webpack_public_path__ + "images/emoji/guitar.4508cdccf0fc9c8bb50d.png";